import React from "react";
import styled from "styled-components";
import { giftcard_images } from "assets/img/giftcard/common";
import { DownloadApp } from "controllers/giftCard/Giftcard.styled";
import {ReactSVG} from "react-svg";
import { CopyToClipboardHelper } from "lib/copyToClipboardHelper";

const Box = styled.div`
    display: flex;
    align-items: center;
    padding: 2px;
    margin-top: 20px;
    z-index: 4;

    border-radius: 999px;
    background: rgb(0, 29, 75);
    background: linear-gradient(
        61deg,
        rgba(0, 29, 75, 1) 0%,
        rgba(0, 49, 122, 1) 30%,
        rgba(0, 64, 164, 1) 52%,
        rgba(0, 49, 122, 1) 70%,
        rgba(0, 29, 75, 1) 100%
    );
    gap: 10px;

    > div:first-child {
        display: flex;
        align-items: center;
        background: hsla(0, 0%, 100%, 0.1);
        padding: 10px 24px;
        border-radius: 999px;
        width: 100%;
        gap: 10px;

        div {
            display:flex;
            cursor:pointer;

            svg {
                width: 18px;
                height: 18px;

                path {
                    fill: #ccc;
                }
            }
        }
    }

    p {
        font-family: monospace, monospace;
        font-size: 20px;
        background: linear-gradient(
            180deg,
            #ffffff 0%,
            rgba(255, 255, 255, 0.7) 100%
        );
        -webkit-background-clip: text;
        -webkit-text-fill-color: transparent;
        margin: 0;
    }

    @media screen and (max-width: 768px) {
        text-align: center;
        width: 50vw;

        > div:first-child {
            flex-direction: column;
            justify-content: center;
        }

        p {
            font-size: 18px;
        }
    }

    @media screen and (max-width: 540px) {
        width: 100%;
    }
`;

const CodeInput = ({ code = "" }) => {
    function copyToClipboard(event) {
        event.preventDefault();
        let copyToClipboardHelper = new CopyToClipboardHelper();
        copyToClipboardHelper.copyToClipboard(code);
        alert("Código copiado al portapapeles")
    };

    return (
        <>
            <Box>
                <div>
                    <p>{code}</p>
                    <ReactSVG src={giftcard_images.giftcardCopy} onClick={copyToClipboard} />
                </div>
            </Box>

        </>
    );
};

export default CodeInput;
